module.exports = __webpack_public_path__ + "media/images/icons/icn_013-e8c87ef6d075072ebfd081c626379bfc.svg";